import { useState } from "react";
import Button from "../../../../Custom/Button/Button";
import styles from "../styles";
import CustomSelect from "../../globalno-dodavanje/CustomSelect";
import CustomSelectSimple from "../CustomSelectSimple";

const idBrojAll = ["CAS BROJ", "ES BROJ", "INDEKS"];
const klaseAll = ["KLASA 1", "KLASA 2", "KLASA 3", "KLASA 4"];
const izlozenostAll = ["DNEVNO", "NEDELJNO", "MESECNO"];

const emptyFilter = {
  radnoMesto: { id: -1, name: "" },
  zaposlen: { id: -1, name: "" },
  id_broj: "",
  klasa: "",
  izlozenost: "",
};

function Filtriranje({ allData, setFilteredData, setCurrentState, lookups }) {
  const [filterData, setFilterData] = useState(emptyFilter);

  const handleChange = (val, field) => setFilterData(prev => ({ ...prev, [field]: val }));

  const handleFiltriraj = () => {
    setFilteredData(allData.filter(d =>
      (filterData.radnoMesto.id === -1 || String(d.workplace_id) === String(filterData.radnoMesto.id)) &&
      (filterData.zaposlen.id === -1 || String(d.employee_id) === String(filterData.zaposlen.id)) &&
      (!filterData.id_broj || d.id_broj === filterData.id_broj) &&
      (!filterData.klasa || d.klasa === filterData.klasa) &&
      (!filterData.izlozenost || d.izlozenost === filterData.izlozenost)
    ));
    setCurrentState("");
  };

  const handleOdustani = () => { setFilteredData(allData); setCurrentState(""); };

  return (
    <div style={{ display: "flex", gap: "10px", justifyContent: "space-between" }}>
      <div style={{ width: "15vw" }}>
        <CustomSelect label="RADNO MESTO" allValues={lookups.radna_mesta || []}
          selectedValue={filterData.radnoMesto} onSelectChange={v => handleChange(v, "radnoMesto")} />
      </div>
      <div style={{ width: "15vw" }}>
        <CustomSelect label="IME I PREZIME" allValues={lookups.zaposleni || []}
          selectedValue={filterData.zaposlen} onSelectChange={v => handleChange(v, "zaposlen")} />
      </div>
      <div style={{ width: "10vw" }}>
        <CustomSelectSimple label="ID BROJ" allValues={idBrojAll}
          selectedValue={filterData.id_broj} onSelectChange={v => handleChange(v, "id_broj")} isUp />
      </div>
      <div style={{ width: "10vw" }}>
        <CustomSelectSimple label="KLASA" allValues={klaseAll}
          selectedValue={filterData.klasa} onSelectChange={v => handleChange(v, "klasa")} isUp />
      </div>
      <div style={{ width: "10vw" }}>
        <CustomSelectSimple label="IZLOŽENOST" allValues={izlozenostAll}
          selectedValue={filterData.izlozenost} onSelectChange={v => handleChange(v, "izlozenost")} isUp />
      </div>
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
        <div onClick={handleOdustani} style={{ height: "40px" }}>
          <Button activation={true} style={styles.button}><span style={{ fontWeight: "bold" }}>ODUSTANI</span></Button>
        </div>
        <div onClick={handleFiltriraj} style={{ height: "40px" }}>
          <Button activation={true} style={styles.button}><span style={{ fontWeight: "bold" }}>PRIMENI</span></Button>
        </div>
      </div>
    </div>
  );
}

export default Filtriranje;